import {DatePicker as AntDatePicker} from "antd";

export const DatePicker = AntDatePicker;
export default DatePicker;
